import LoginView from 'src/sections/auth/view/login-view';

export default function LoginPage() {
  return <LoginView />;
}
